import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import LineChartComponent from './paymentscore_linechart';
import { connect } from 'react-redux';
import * as CHART_CONSTANT from './../constants';
import BusinessBrekupBarChartComponent from './breakup_business_bar_chart';
import ComparativePaymentBehaviourChartComponent from './comparativePaymentBehaviourChart';
import { fetchBreakupBusinessDataRequest, fetchCUGPaymentScoreDataRequest, fetchMonthsFilter } from '../action'
import CreditLimitUtilizationChart from './creditLimitUtilizationBarChart';
import PaymentDelinquencyChart from './paymentDelinquencyChart';
import SaleReturnChart from './salesReturnChart';
import moment from 'moment';
import '../constants';
import ChartDescriptorPopover from './chart-descriptor-popover';
import { Preloading } from '../../../../components/UI/Preloader/action';
import PaymentRiskScoreMeter from './paymentRiskScoreMeter';
import CreditTermTable from './creditTermTable';
import { CUGHeader } from './cug-header';
import CUGDateFilter from './cug-report-date-filter';

const typeFilters = [CHART_CONSTANT.LOOSE_DIAMOND_SALE, CHART_CONSTANT.JOB_WORK, CHART_CONSTANT.FINISHED_JEWELRY_SALE, CHART_CONSTANT.OVERALL];
class CugCharts extends Component {

    state = {
        counterpartyName: "",
        corporateName: "",
        paymentScoreData: [],
        breakBusinessData: [],
        comparativePaymentData: [],
        creditLimitData: [],
        saleReturnData: [],
        paymentDeliquencyData: [],
        monthfilters: [],
        creditTermdays :[],
        popoverOpen: false,
        target_id:'A',
        description:'A',
        chart_name:'-',
        totalMonthsData : 15
    }

    fetchCUGDataWithDateFilters = (startDate, endDate, months) => {
        this.props.preloading(true);
        this.props.fetchCUGPaymentScoreDataRequest({ ...this.props.match.params, startDate : startDate , endDate : endDate});
        this.setState({ totalMonthsData : months-1 })
    }

    componentDidMount() {
        this.props.preloading(true);
        if (this.props.cugCorporateData) {
            this.props.fetchCUGPaymentScoreDataRequest({ ...this.props.match.params, "startDate" : "", "endDate" : "" });
            this.setState({ counterpartyName: this.props.cugCorporateData.counterpartyName, corporateName: this.props.cugCorporateData.corporateName, totalMonthsData : 15 })
        }else{
            this.props.fetchCUGPaymentScoreDataRequest({ ...this.props.match.params, "startDate" : "", "endDate" : "" });
        }
    }

    getFormatedMonthYear = (value) => {
        if (value && value != undefined && value != null) {
            return moment(value).format('MMM-YY');
        } else {
            return "";
        }
    }

    handleData = (data) => {
        let paymentScoreData = [];
        let breakBusinessData = [];
        let creditLimitData = [];
        let paymentDeliquencyData = [];
        let comparativePaymentData = [];
        let saleReturnData = [];
        let creditTermdays = [];
        let monthfilters = {};

        if (data && data.length > 0) {
            data.map(dataObject => {

                let monthYear = this.getFormatedMonthYear(dataObject.recordDate);
                monthfilters = { ...monthfilters, [monthYear]: monthYear };
                paymentScoreData = [
                    ...paymentScoreData,
                    {
                        type: dataObject.businessType,
                        me: dataObject.myPaymentScore,
                        cug_member: dataObject.otherCugPaymentScore,
                        portfolio: dataObject.portfolioPaymentScore,
                        cug: dataObject.cugPaymentScore,
                        name: monthYear
                    }
                ];
                breakBusinessData = [
                    ...breakBusinessData,
                    {
                        name: `${this.state.counterpartyName} (With Me)`,
                        [dataObject.businessType]: Math.round(dataObject.myBreakup*100),
                        month: monthYear,
                        type: "WITH_ME"
                    },
                    {
                        name: `${this.state.counterpartyName} (With Other CUG Members)`,
                        [dataObject.businessType]: Math.round(dataObject.otherCugBreakup*100),
                        month: monthYear,
                        type: "WITH_OTHERS"
                    }
                ];

                creditLimitData = [
                    ...creditLimitData,
                    {
                        type: dataObject.businessType,
                        month: monthYear,
                        me: Math.round(dataObject.myCreditLimit*100),
                        cug: Math.round(dataObject.otherCreditLimit*100)
                    }
                ]
                comparativePaymentData = [
                    ...comparativePaymentData,
                    {
                        name: `${this.state.counterpartyName} (With Me)`,
                        beforeDueDate: Math.round(dataObject.myNotDue*100),
                        _0_30_days: Math.round(dataObject.myDueBetween0to30days*100),
                        _31_60_days: Math.round(dataObject.myDueBetween30to60days*100),
                        _61_90_days: Math.round(dataObject.myDueBetween60to90days*100),
                        _91_120_days: Math.round(dataObject.myDueBetween90to120days*100),
                        _121_180_days: Math.round(dataObject.myDueBetween120to180days*100),
                        _180_plus_days: Math.round(dataObject.myDueMoreThan180days*100),
                        month: monthYear,
                        type: dataObject.businessType,
                        dispalyType: "WITH_ME"
                    },
                    {
                        name: `${this.state.counterpartyName} (With Other CUG Members)`,
                        beforeDueDate: Math.round(dataObject.othersNotDue*100),
                        _0_30_days: Math.round(dataObject.othersDueBetween0to30days*100),
                        _31_60_days: Math.round(dataObject.othersDueBetween30to60days*100),
                        _61_90_days: Math.round(dataObject.othersDueBetween60to90days*100),
                        _91_120_days: Math.round(dataObject.othersDueBetween90to120days*100),
                        _121_180_days: Math.round(dataObject.othersDueBetween120to180days*100),
                        _180_plus_days: Math.round(dataObject.othersDueMoreThan180days*100),
                        month: monthYear,
                        type: dataObject.businessType,
                        dispalyType: "WITH_OTHERS"
                    }
                ];

                saleReturnData = [
                    ...saleReturnData,
                    {
                        type: dataObject.businessType,
                        month: monthYear,
                        me: Math.round(dataObject.mySalesReturn*100),
                        cug: Math.round(dataObject.othersSalesReturn*100)
                    }
                ];
                paymentDeliquencyData = [
                    ...paymentDeliquencyData,
                    {
                        name: monthYear,
                        me: Math.round(dataObject.myDPD),
                        cug_member: Math.round(dataObject.othersDPD),
                        portfolio: Math.round(dataObject.portfolioDPD),
                        cug: Math.round(dataObject.cugDPD),
                        type: dataObject.businessType,
                    }
                ];

                creditTermdays = [
                    ...creditTermdays,
                    {
                        type : dataObject.businessType,
                        month : monthYear,
                        myCreditDays : dataObject.myCreditDays,
                        minOthersCreditDays : dataObject.minOthersCreditDays,
                        maxOthersCreditDays : dataObject.maxOthersCreditDays
                    }
                ]
            });
        }
        this.setState(
            {
                monthfilters: Object.keys(monthfilters), paymentScoreData: paymentScoreData, breakBusinessData: breakBusinessData, comparativePaymentData: comparativePaymentData, creditLimitData: creditLimitData, saleReturnData: saleReturnData, paymentDeliquencyData: paymentDeliquencyData, creditTermdays: creditTermdays
            },
            () => {
               // console.log(this.state)
            })
    }

    componentDidUpdate(prevProps) {
        if (this.props.cugPaymentScoreData !== prevProps.cugPaymentScoreData) {
            this.props.preloading(false);
            this.setState({ cugPaymentScoreData: this.props.cugPaymentScoreData })
            this.handleData(this.props.cugPaymentScoreData.cugReportData);
            this.setState({ counterpartyName: this.props.cugPaymentScoreData.counterpartyName, corporateName: this.props.cugPaymentScoreData.corporateName, paymentScore: this.props.cugPaymentScoreData.paymentScore,
                noOfMembers: this.props.cugPaymentScoreData.noOfMembers, noOfMonths: this.props.cugPaymentScoreData.noOfMonths, noOfTradelines: this.props.cugPaymentScoreData.noOfTradelines
            })
        }
    }

    descriptionPopoverToggle = (target_id, chart_name) => {
        let description = null;
        if(chart_name){
            switch(chart_name){
                case CHART_CONSTANT.PAYMENT_SCORE: description = CHART_CONSTANT.PAYMENT_SCORE_DESCRIPTION; break;
                case CHART_CONSTANT.BREAKUP_OF_BUSINESS_TYPE: description = CHART_CONSTANT.BREAKUP_OF_BUSINESS_TYPE_DESCRIPTION; break;
                case CHART_CONSTANT.COMPARATIVE_PAYMENT_BEHAVIOUR: description = CHART_CONSTANT.COMPARATIVE_PAYMENT_BEHAVIOUR_DESCRIPTION; break;
                case CHART_CONSTANT.CREDIT_LIMIT_UTILISATION: description = CHART_CONSTANT.CREDIT_LIMIT_UTILISATION_DESCRIPTION; break;
                case CHART_CONSTANT.PAYMENT_DELINQUENCY: description = CHART_CONSTANT.PAYMENT_DELINQUENCY_DESCRIPTION; break;
                case CHART_CONSTANT.SALES_RETURN: description = CHART_CONSTANT.SALES_RETURN_DESCRIPTION; break;
                case CHART_CONSTANT.CREDIT_TERMS_DAYS : description = CHART_CONSTANT.CREDIT_TERMS_DAYS_DESCRIPTION;break;
                case CHART_CONSTANT.NOTE : description = CHART_CONSTANT.RUBIX_PAYMENT_RISK_SCORE_DESCRIPTION;break;
            }
        }

        this.setState({
            popoverOpen:!this.state.popoverOpen,
            target_id,
            description,
            chart_name
        }, ()=>{ // state change done
            
        });
    }

    chartPopoverToggle = () => {
        this.descriptionPopoverToggle(null, null);
    }

    render() {
        return (
            <React.Fragment>
                <div className="p-3 flex-grow-1">
                    <Breadcrumb className="mb-3">
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem ><Link to="/cug-portfolio/1">CUG Portolio</Link></BreadcrumbItem>
                        <BreadcrumbItem active>CUG Report </BreadcrumbItem>
                    </Breadcrumb>
                    <CUGHeader counterpartyName = {this.state.counterpartyName} />

                    {/*<PaymentRiskScoreMeter paymentScore ={this.state.paymentScore} noOfMonths = {this.state.totalMonthsData} noOfMembers = {this.state.noOfMembers} noOfTradelines ={this.state.noOfTradelines} descriptionPopoverToggle={this.descriptionPopoverToggle} />*/}
                    <PaymentRiskScoreMeter paymentScore ={this.state.paymentScore} noOfMonths = {this.state.noOfMonths} noOfMembers = {this.state.noOfMembers} noOfTradelines ={this.state.noOfTradelines} descriptionPopoverToggle={this.descriptionPopoverToggle} />

                    <CUGDateFilter fetchDetail = {this.fetchCUGDataWithDateFilters}/>

                    <LineChartComponent counterpartyName={this.state.counterpartyName} corporateName={this.state.corporateName} typeFilters={typeFilters} chartData={this.state.paymentScoreData} descriptionPopoverToggle={this.descriptionPopoverToggle} />

                    <BusinessBrekupBarChartComponent chartData={this.state.breakBusinessData} monthfilters={this.state.monthfilters} descriptionPopoverToggle={this.descriptionPopoverToggle} />

                    <CreditLimitUtilizationChart chartData={this.state.creditLimitData} typeFilters={typeFilters} counterpartyName={this.state.counterpartyName} descriptionPopoverToggle={this.descriptionPopoverToggle} />

                    <CreditTermTable creditTermDays = {this.state.creditTermdays}  monthfilters={this.state.monthfilters}  descriptionPopoverToggle={this.descriptionPopoverToggle} />
                    <ComparativePaymentBehaviourChartComponent chartData={this.state.comparativePaymentData} monthfilters={this.state.monthfilters} typeFilters={typeFilters} descriptionPopoverToggle={this.descriptionPopoverToggle} />

                    <PaymentDelinquencyChart chartData={this.state.paymentDeliquencyData} counterpartyName={this.state.counterpartyName} corporateName={this.state.corporateName} typeFilters={typeFilters} descriptionPopoverToggle={this.descriptionPopoverToggle} />

                    <SaleReturnChart chartData={this.state.saleReturnData} typeFilters={typeFilters} counterpartyName={this.state.counterpartyName} descriptionPopoverToggle={this.descriptionPopoverToggle} />

                    
                    <ChartDescriptorPopover
                        popoverOpen={this.state.popoverOpen}
                        targetId={this.state.target_id}
                        toggle={this.chartPopoverToggle}
                        header={this.state.chart_name}
                        body={this.state.description} />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    cugPortfoliioList: state.cugPortfolio.cugPortfoliioList,
    cugCorporateData: state.cugPortfolio.cugCorporateData,
    cugPaymentScoreData: state.cugPortfolio.cugPaymentScoreData,
    monthFilters: state.cugPortfolio.monthFiltrs,
    breakupOfBusinessData: state.cugPortfolio.breakupOfBusinessData
});

const mapDispatchToProps = dispatch => ({
    fetchCUGPaymentScoreDataRequest: (data) => { dispatch(fetchCUGPaymentScoreDataRequest(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default connect(mapStateToProps, mapDispatchToProps)(CugCharts);
